import {
	getFilteredList,
	getParentId,
	getConvertedList,
	convertListItem,
	roundWith2Decimals,
	decodedEqual,
} from './pmiHeroChartDataConverter';

const GROUPPING_LIMIT = 8;

export const pmiTreeChartDataConverter = {
	convert(data, params) {
		const { nonAddressableData, addressableData } = data;
		const { categoryLevel, categoryName, showNonSourceable } = params;

		const parentId = getParentId(params);
		const list = showNonSourceable ? nonAddressableData : addressableData;

		return {
			parentId,
			categoryName,
			categoryLevel,
			tailSpend: getTailSpendTree(list, params),
			categorization: getConvertedTree(list, params),
		};
	},
};

const getConvertedTree = (list, params) => {
	let filteredList = getFilteredList(list, params);

	filteredList = filteredList.map(categoryItem => {
		const paramsForCategory = {
			...params,
			// show content of current category item
			overrideParentId: categoryItem.id,
			// override groupping for tree - based on max count, not value
			othersCountThreshold: GROUPPING_LIMIT,
			showAllCategories: false,
		};

		return getTreeForCategory(categoryItem, list, paramsForCategory);
	});

	filteredList = filteredList.filter(item => !!item.value);

	const valueSorter = ({ value: a }, { value: b }) => b - a;
	filteredList.sort(valueSorter);

	return filteredList;
};

const getTreeForCategory = (category, list, params) => {
	let subCategories = getConvertedList(list, params).filter(
		item => !item.isTailSpend && !!item.value
	);

	if (category.depth === 5) {
		subCategories =
			subCategories && subCategories.length > 0 ? subCategories : [category];
	}

	let categoryValue = subCategories.reduce((sum, item) => sum + item.value, 0);

	categoryValue = roundWith2Decimals(categoryValue);

	return {
		name: category.label,
		value: categoryValue,
		subCategories,
	};
};

const getTailSpendTree = (list, params) => {
	const parentId = getParentId(params);

	let tailSpendItem = list
		.filter(item => decodedEqual(item.parentId, parentId))
		.find(item => item.isTailVendorsNode);

	tailSpendItem = tailSpendItem
		? convertListItem(tailSpendItem)
		: {
				value: 0,
				subCategories: [],
				splitByDimension: {},
		  };

	const paramsForCategory = {
		...params,
		// tail spend is never included into subcategories as separate item
		// so all tail spend is displayed here
		showTailSpend: true,
		isTailSpend: true,
		// override groupping for tree - based on max count, not value
		othersCountThreshold: GROUPPING_LIMIT,
		showAllCategories: false,
	};

	let subCategories = getConvertedList(list, paramsForCategory);
	subCategories = subCategories.filter(item => !!item.value);

	let categoryValue = subCategories.reduce((sum, item) => sum + item.value, 0);
	categoryValue = roundWith2Decimals(categoryValue);

	return {
		splitByDimension: tailSpendItem.splitByDimension,
		value: categoryValue,
		subCategories,
	};
};
